import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { initSentry } from './utils/sentry';

try {
  initSentry();
} catch (error) {
  console.error('Sentry initialization error:', error);
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

// Enable dev mode for info buttons
(window as any).__DEV_MODE__ = true;

// Suppress websocket and HMR errors in development (they're harmless but cause visual glitching)
if (import.meta.env.DEV) {
  const originalError = console.error;
  const originalWarn = console.warn;
  
  console.error = (...args: any[]) => {
    const msg = String(args[0]);
    if (msg.includes('WebSocket') || msg.includes('HMR') || msg.includes('[vite]')) {
      return; // Suppress
    }
    originalError.apply(console, args);
  };
  
  console.warn = (...args: any[]) => {
    const msg = String(args[0]);
    if (msg.includes('WebSocket') || msg.includes('HMR') || msg.includes('[vite]')) {
      return; // Suppress
    }
    originalWarn.apply(console, args);
  };
}

const root = ReactDOM.createRoot(rootElement);

try {
  root.render(
    // Disable StrictMode to prevent double renders that cause stuttering
    // <React.StrictMode>
      <App />
    // </React.StrictMode>
  );
} catch (error) {
  console.error('Error rendering app:', error);
  root.render(
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <h1>Error Loading App</h1>
      <p>{error instanceof Error ? error.message : 'Unknown error'}</p>
      <p>Please check the console for details.</p>
    </div>
  );
} 